import {
    PracticeAreaTitle,
    PracticeArea,
    PracticeAreaInTheseAreas,
   } from './style'
import React  from 'react';
import { PracticeAreaFourCards } from './practiceAreaFourCards';
import Practice1 from '../../image/practice1.png'
import Practice2 from '../../image/practice2.png'
import Practice3 from '../../image/practice3.png'
import Practice4 from '../../image/practice4.png'
  

const firstCard = {
  title: 'Dispute Resolution',
  description: 'With extensive experience in negotiation, mediation, and arbitration, we are dedicated to protecting your interests and achieving optimal results.',
  image: Practice1
} 

const secondCard = {
  title: 'Commercial Litigation',
  description: 'Expert commercial litigation services for businesses, offering strategic advice and  effective advocacy.',
  image: Practice2
}

const thirdCard = {
  title: 'Bankruptcy & Debt Payment Suspension',
  description: 'We help you by navigate financial difficulties and find effective solutions to regain stability.',
  image: Practice3
}

const forthCard = {
  title: 'Arbitration & Dispute Resolution',
  description: 'Offering expert arbitration and dispute resolution services to efficiently resolve conflicts, protect your interests.',
  image: Practice4
}

export const PracticeAreaComponent = () => {
    return (
        <PracticeArea>
          <PracticeAreaTitle>
            WE PRACTICE{" "}
            <PracticeAreaInTheseAreas>
              IN THESE AREAS
            </PracticeAreaInTheseAreas>
          </PracticeAreaTitle>
          <PracticeAreaFourCards
            firstCard={firstCard}
            secondCard={secondCard}
            thirdCard={thirdCard}
            forthCard={forthCard}
          />
        </PracticeArea>
    )
}
